// packages/shared-i18n/components/LanguageSwitcher.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, LanguageType, switchAppLanguage } from "../i18n";
import "./LanguageSwitcher.css";
import { Iconfont } from "../../shared-components/src/components/Iconfont/Iconfont";
import { Dropdown } from "../../shared-components/src/components/Dropdown";
import type { DropdownOption } from "../../shared-components/src/components/Dropdown/types";

interface LanguageSwitcherProps {
  onLanguageChange?: (language: LanguageType) => void;
  /** hover 下拉互斥组，与 Header 其它 hover 菜单共用时可避免多层叠加 */
  exclusiveHoverGroup?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  onLanguageChange,
  exclusiveHoverGroup,
}) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language as LanguageType;

  const handleLanguageChange = (key: string) => {
    const language = key as LanguageType;
    if (language === currentLanguage) return;
    // 主应用通过 onLanguageChange → globalStore.setLanguage（含 qiankun）；独立场景走 switchAppLanguage
    if (onLanguageChange) {
      onLanguageChange(language);
      return;
    }
    void switchAppLanguage(language);
  };

  const languageOptions: DropdownOption[] = Object.entries(LANGUAGES).map(
    ([key, label]) => ({
      key,
      label,
      // 不设 disabled，否则 <button disabled> 无法触发 :hover，选中项会没有 hover 动画
    })
  );

  return (
    <Dropdown
      trigger="hover"
      options={languageOptions}
      value={currentLanguage}
      onSelect={handleLanguageChange}
      className="language-switcher"
      menuClassName="language-switcher-panel"
      exclusiveHoverGroup={exclusiveHoverGroup}
    >
      <button
        type="button"
        className="header-action-btn language-switcher-btn"
        aria-label={t("common.language")}
      >
        <Iconfont icon="language" className="header-action-icon" />
      </button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
